import { Bot, BotMessageSquare, Cpu } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Robot/AI icon set cycled inside loading circles (see `CyclingIcon`). Nearest
 * lucide matches to the designer's robot reference set — lucide ships no
 * full-body bot, so the standing robot maps to `Cpu`. Shared so every
 * processing surface (content-enrichment funnel + delivery card) cycles the
 * same icons.
 */
export const BOT_LOADING_ICONS: LucideIcon[] = [Bot, Cpu, BotMessageSquare];
